import * as React from 'react';

import { useToast } from '@rematter/ui-web/hooks';
import { useSetAtom } from 'jotai';

import { $generateFileAccessURL } from './useFileDownloadUrl';

const FILE_URL_EXPIRY_SECONDS = 3600;

type FileWithDownloadUrl = {
  id: string;
  fileName: string;
  downloadUrl?: string;
};

const triggerDownload = (url: string, fileName: string) => {
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const useFileDownload = () => {
  const toast = useToast();
  const generateDownloadUrl = useSetAtom($generateFileAccessURL);
  const [isGeneratingDownloadUrl, setIsGeneratingDownloadUrl] =
    React.useState(false);

  const downloadFile = async (file: FileWithDownloadUrl) => {
    try {
      setIsGeneratingDownloadUrl(true);
      let downloadUrl = file.downloadUrl;

      if (!downloadUrl) {
        const result = await generateDownloadUrl({
          fileIds: [file.id],
          expirySeconds: FILE_URL_EXPIRY_SECONDS,
        });
        downloadUrl = result.filesGenerateFileAccessURL.results[0].url ?? '';
      }

      triggerDownload(downloadUrl, file.fileName);
    } catch {
      toast.error(`Failed to download ${file.fileName}`);
    } finally {
      setIsGeneratingDownloadUrl(false);
    }
  };

  return {
    downloadFile,
    isGeneratingDownloadUrl,
  };
};
